import { inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { LocalStorageService } from '../shared/services/ecommerce/localstorage.service';

@Injectable({
	providedIn: 'root'
})
export class Paso4Guard implements CanActivate {
	private localStorageService = inject(LocalStorageService);
	constructor(private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const datosBusqueda = this.localStorageService.getItemByIndex('busqueda', 0);
		const itinerarioIda = this.localStorageService.getItemByIndex('itinerarioIda', 0);
		const itinerarioVuelta = this.localStorageService.getItemByIndex('itinerarioVuelta', 0);
		const pasajerosIda = this.localStorageService.getItemByIndex('pasajerosIda', 0);
		const pasajerosVuelta = this.localStorageService.getItemByIndex('pasajerosVuelta', 0);
		const datosContacto = this.localStorageService.getItemEncrypt('datosContacto');
		const pasajerosVenta = this.localStorageService.getItemEncrypt('pasajerosVenta');
		const { url_amigable, fecha_regreso } = datosBusqueda;
		const paramUrlAmigable = route.paramMap.get('slug');

		// 1. Comprobar si el objeto existe, si no, redireccionar a home
		if (!datosBusqueda || !itinerarioIda || !pasajerosIda || !pasajerosVenta || !datosContacto) {
			this.router.navigate(['/']);
			return false;
		}
		if (fecha_regreso !== '' && (!itinerarioVuelta || !pasajerosVuelta)) {
			this.router.navigate(['/']);
			return false;
		}
		if (paramUrlAmigable !== url_amigable) {
			this.router.navigate([`/pasajes-en-bus/paso4/${url_amigable}/checkout`]);
			return false;
		}

		return true;
	}
}
